import { useState } from "react";
import { createPortal } from "react-dom";
import { MessageCircle, X } from "lucide-react";
import ContactForm from "@/components/ContactForm";

export default function LiveChatButton() {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        data-testid="live-chat-button"
        onClick={() => setOpen(true)}
        className="fixed bottom-6 right-6 z-40 bg-[var(--dm-emerald)] hover:bg-[var(--dm-emerald-2)] text-white pl-4 pr-5 py-3 shadow-lg inline-flex items-center gap-2 transition-colors"
      >
        <MessageCircle className="w-4 h-4" />
        <span className="text-sm font-medium">Chat with us</span>
      </button>

      {open && createPortal(
        <div data-testid="live-chat-modal" className="fixed inset-0 z-[9999] bg-black/60 flex items-center justify-center p-4" onMouseDown={(e) => { if (e.target === e.currentTarget) setOpen(false); }}>
          <div className="bg-white w-full max-w-2xl max-h-[92vh] overflow-y-auto border border-[var(--dm-border)]" onMouseDown={(e) => e.stopPropagation()}>
            <div className="flex items-center justify-between p-5 border-b border-[var(--dm-border)] bg-[var(--dm-navy)] text-white">
              <div>
                <div className="dm-overline text-white/70">Live chat</div>
                <div className="font-serif text-xl">How can we help?</div>
              </div>
              <button data-testid="live-chat-close" onClick={() => setOpen(false)} className="p-2 hover:bg-white/10"><X className="w-4 h-4" /></button>
            </div>
            <div className="p-6">
              <p className="text-sm text-[var(--dm-muted)] mb-6">A senior consultant will reply within one business hour. Prefer a call? Book a free 30-minute consultation from the Contact page.</p>
              <ContactForm sourcePage="live-chat" onSuccess={() => setOpen(false)} compact />
            </div>
          </div>
        </div>,
        document.body
      )}
    </>
  );
}
